import { render, staticRenderFns } from "./ProjectAcceleration.vue?vue&type=template&id=53921a8f&scoped=true&"
import script from "./ProjectAcceleration.vue?vue&type=script&lang=js&"
export * from "./ProjectAcceleration.vue?vue&type=script&lang=js&"
import style0 from "./ProjectAcceleration.vue?vue&type=style&index=0&id=53921a8f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53921a8f",
  null
  
)

export default component.exports